import { render, staticRenderFns } from "./price-list.vue?vue&type=template&id=776b4164&"
import script from "./price-list.vue?vue&type=script&lang=js&"
export * from "./price-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776b4164')) {
      api.createRecord('776b4164', component.options)
    } else {
      api.reload('776b4164', component.options)
    }
    module.hot.accept("./price-list.vue?vue&type=template&id=776b4164&", function () {
      api.rerender('776b4164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24dGlewkPm8C3/JS/comp/price-list.vue"
export default component.exports